var i = /* @__PURE__ */ ((s) => (s.one_shot = "one_shot", s.subscription = "subscription", s.limited_subscription = "limited_subscription", s))(i || {});
export {
  i as PricePlanTypeEnum
};
